// src/services/api.js
//  const API_BASE_URL = 'http://localhost/college-website/backend/api';
//  const API_BASE_URL = 'https://dronaindps.edu.in/backend/api';
// const API_BASE_URL = 'https://keboardcs.edu.in/backend/api';
// const API_BASE_URL = 'https://kushmainstitutions.com/backend/api';
//  const API_BASE_URL = 'https://kushmaeducationsociety.org/backend/api';
// const API_BASE_URL = 'https://vcblngsr.com/backend/api';
 const API_BASE_URL = 'https://sbeshukkeri.org/backend/api';


// Helper function for API calls
const apiRequest = async (endpoint, options = {}) => {
  const token = localStorage.getItem('admin_token');
  
  const config = {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  };
  
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  
  if (config.body && typeof config.body === 'object') {
    config.body = JSON.stringify(config.body);
  }
  
  console.log(`📤 API Request: ${API_BASE_URL}${endpoint}`);
  
  try {
    const response = await fetch(`${API_BASE_URL}${endpoint}`, config);
    
    console.log(`📥 Response Status: ${response.status}`);
    
    // Check if response is JSON
    const contentType = response.headers.get('content-type');
    if (!contentType || !contentType.includes('application/json')) {
      const text = await response.text();
      console.error('Non-JSON response:', text);
      throw new Error(`Server returned non-JSON: ${text.substring(0, 100)}`);
    }
    
    const data = await response.json();
    console.log('✅ API Response:', data);
    
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem('admin_token');
        localStorage.removeItem('admin_user');
        window.location.href = '/admin/login';
        return null;
      }
      throw new Error(data.message || `HTTP error ${response.status}`);
    }
    
    return data;
    
  } catch (error) {
    console.error('❌ API Request Failed:', error);
    throw error;
  }
};


export const BASE_URL = API_BASE_URL;
export const UPLOAD_BASE_URL = API_BASE_URL.replace(/\/api$/, '');

// ==================== AUTH API ====================
export const authAPI = {
  login: async (username, password) => {
    console.log('🔐 Login attempt:', username);
    try {
      const result = await apiRequest('/auth.php?action=login', {
        method: 'POST',
        body: { username, password },
      });
      return result;
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },
  
  logout: async () => {
    try {
      await apiRequest('/auth.php?action=logout', {
        method: 'POST',
      });
    } finally {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    }
  },
  
  checkAuth: async () => {
    try {
      return await apiRequest('/auth.php?action=check');
    } catch {
      return { success: false };
    }
  },
  
  getCurrentUser: () => {
    try {
      const userStr = localStorage.getItem('admin_user');
      return userStr ? JSON.parse(userStr) : null;
    } catch {
      return null;
    }
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem('admin_token');
  },

  // ============ ADDED: CHANGE PASSWORD API ============
  changePassword: async (data) => {
    console.log('🔑 Change password attempt');
    try {
      const result = await apiRequest('/change_password.php', {
        method: 'POST',
        body: data,
      });
      return result;
    } catch (error) {
      console.error('Change password failed:', error);
      throw error;
    }
  }
};


// ==================== ACADEMIC YEARS API ====================
export const academicYearsAPI = {
  getAll: async () => {
    try {
      const response = await apiRequest('/academic_years.php?action=getAll');
      
      console.log('Academic Years API Response:', response);
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || [],
          message: response.message || '',
          count: response.count || 0
        };
      } else {
        return {
          success: false,
          message: 'Invalid response from server',
          data: [],
          count: 0
        };
      }
    } catch (error) {
      console.error('Academic Years API Error:', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: [],
        count: 0
      };
    }
  },
  
  create: async (data) => {
    try {
      const response = await apiRequest('/academic_years.php?action=create', {
        method: 'POST',
        body: data,
      });
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        id: response?.id || null,
        data: response?.data || null
      };
    } catch (error) {
      console.error('Create academic year error:', error);
      return {
        success: false,
        message: error.message || 'Create failed'
      };
    }
  },
  
  update: async (id, data) => {
    try {
      const response = await apiRequest(`/academic_years.php?action=update&id=${id}`, {
        method: 'POST',
        body: data,
      });
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        data: response?.data || null
      };
    } catch (error) {
      console.error('Update academic year error:', error);
      return {
        success: false,
        message: error.message || 'Update failed'
      };
    }
  },
  
  delete: async (id) => {
    try {
      const response = await apiRequest(`/academic_years.php?action=delete&id=${id}`, {
        method: 'POST',
      });
      
      return {
        success: response?.success || false,
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Delete academic year error:', error);
      return {
        success: false,
        message: error.message || 'Delete failed'
      };
    }
  },
  
  toggleStatus: async (id) => {
    try {
      const response = await apiRequest(`/academic_years.php?action=toggleStatus&id=${id}`, {
        method: 'POST',
      });
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        data: response || null
      };
    } catch (error) {
      console.error('Toggle status error:', error);
      return {
        success: false,
        message: error.message || 'Toggle status failed'
      };
    }
  }
};

// ==================== DEPARTMENTS API ====================
export const departmentsAPI = {
  getAll: async () => {
    try {
      const response = await apiRequest('/departments.php?action=getAll');
      
      console.log('Departments API Response:', response);
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || [],
          message: response.message || '',
          count: response.data?.length || 0
        };
      } else {
        return {
          success: false,
          message: 'Invalid response from server',
          data: [],
          count: 0
        };
      }
    } catch (error) {
      console.error('Departments API Error:', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: [],
        count: 0
      };
    }
  },
  
  getById: async (id) => {
    try {
      const response = await apiRequest(`/departments.php?action=getById&id=${id}`);
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        data: response?.data || null
      };
    } catch (error) {
      console.error('Get department by ID error:', error);
      return {
        success: false,
        message: error.message || 'Get department failed'
      };
    }
  },
  
  create: async (data) => {
    try {
      const response = await apiRequest('/departments.php?action=create', {
        method: 'POST',
        body: data,
      });
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        data: response?.data || null
      };
    } catch (error) {
      console.error('Create department error:', error);
      return {
        success: false,
        message: error.message || 'Create failed'
      };
    }
  },
  
  update: async (id, data) => {
    try {
      const response = await apiRequest(`/departments.php?action=update&id=${id}`, {
        method: 'POST',
        body: data,
      });
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        data: response?.data || null
      };
    } catch (error) {
      console.error('Update department error:', error);
      return {
        success: false,
        message: error.message || 'Update failed'
      };
    }
  },
  
  delete: async (id) => {
    try {
      const response = await apiRequest(`/departments.php?action=delete&id=${id}`, {
        method: 'POST',
      });
      
      return {
        success: response?.success || false,
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Delete department error:', error);
      return {
        success: false,
        message: error.message || 'Delete failed'
      };
    }
  }
};


// ==================== PUBLIC API (No Authentication) ====================
export const publicAPI = {
  getDepartments: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/departments.php?action=getAll`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Public API error:', error);
      return { 
        success: false, 
        data: [],
        message: 'Failed to fetch departments'
      };
    }
  },
  
  getCourses: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/courses.php?action=getAll`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Public API error:', error);
      return { 
        success: false, 
        data: [],
        message: 'Failed to fetch courses'
      };
    }
  },
  
  getStaff: async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/staff.php?action=getAll`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Public API error:', error);
      return { 
        success: false, 
        data: [],
        message: 'Failed to fetch staff'
      };
    }
  },
  
  // Mock data fallback
  getMockDepartments: () => {
    return {
      success: true,
      data: [
        { id: 1, name: 'Computer Science', code: 'CS', description: 'Computer Science Department' },
        { id: 2, name: 'Mathematics', code: 'MATH', description: 'Mathematics Department' },
        { id: 3, name: 'Physics', code: 'PHY', description: 'Physics Department' },
        { id: 4, name: 'Chemistry', code: 'CHEM', description: 'Chemistry Department' },
        { id: 5, name: 'Biology', code: 'BIO', description: 'Biology Department' },
        { id: 6, name: 'English', code: 'ENG', description: 'English Department' }
      ]
    };
  },
  
  getMockCourses: () => {
    return {
      success: true,
      data: [
        { id: 1, name: 'Bachelor of Computer Science', code: 'BCS', duration: '3 Years', fee: 50000 },
        { id: 2, name: 'Bachelor of Mathematics', code: 'BMATH', duration: '3 Years', fee: 45000 },
        { id: 3, name: 'Bachelor of Physics', code: 'BPHY', duration: '3 Years', fee: 45000 },
        { id: 4, name: 'Bachelor of Chemistry', code: 'BCHEM', duration: '3 Years', fee: 45000 },
        { id: 5, name: 'Bachelor of Arts', code: 'BA', duration: '3 Years', fee: 40000 },
        { id: 6, name: 'Bachelor of Commerce', code: 'BCOM', duration: '3 Years', fee: 42000 }
      ]
    };
  },
  
  getMockStaff: () => {
    return {
      success: true,
      data: [
        { 
          id: 1, 
          name: 'Dr. John Smith', 
          designation: 'Professor', 
          department: 'Computer Science',
          qualification: 'Ph.D. in Computer Science',
          experience_years: 15,
          email: 'john.smith@college.edu'
        },
        { 
          id: 2, 
          name: 'Dr. Sarah Johnson', 
          designation: 'Associate Professor', 
          department: 'Mathematics',
          qualification: 'Ph.D. in Mathematics',
          experience_years: 12,
          email: 'sarah.j@college.edu'
        },
        { 
          id: 3, 
          name: 'Dr. Michael Brown', 
          designation: 'Professor', 
          department: 'Physics',
          qualification: 'Ph.D. in Physics',
          experience_years: 18,
          email: 'm.brown@college.edu'
        }
      ]
    };
  }
};

// ==================== ABOUT API ====================
export const aboutAPI = {
  getPublic: async () => {
    try {
      const response = await apiRequest('/about.php?action=get');
      
      console.log('About API Response (Public):', response);
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || {},
          message: response.message || '',
        };
      } else {
        return {
          success: false,
          message: 'Invalid response from server',
          data: {}
        };
      }
    } catch (error) {
      console.error('About API Error (Public):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: {}
      };
    }
  },

  getForAdmin: async () => {
    try {
      const response = await apiRequest('/about.php?action=getForAdmin');
      
      console.log('About API Response (Admin):', response);
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || {
            title: '',
            description: '',
            mission: '',
            vision: '',
            objectives: '',
            history: '',
            achievements: '',
            leadership_message: '',
            logo: '',
            campus_image: ''
          },
          message: response.message || '',
        };
      } else {
        return {
          success: false,
          message: 'Invalid response from server',
          data: {}
        };
      }
    } catch (error) {
      console.error('About API Error (Admin):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: {}
      };
    }
  },

  update: async (data) => {
    try {
      const response = await apiRequest('/about.php?action=update', {
        method: 'POST',
        body: data,
      });
      
      return {
        success: response?.success || false,
        message: response?.message || '',
        data: response?.data || null
      };
    } catch (error) {
      console.error('Update about error:', error);
      return {
        success: false,
        message: error.message || 'Update failed'
      };
    }
  },

  uploadImage: async (type, imageFile) => {
    try {
      const token = localStorage.getItem('admin_token');
      const formData = new FormData();
      formData.append('image', imageFile);
      
      console.log('Uploading image:', type, imageFile.name);
      
      const response = await fetch(`${API_BASE_URL}/about.php?action=uploadImage&type=${type}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`
        },
        body: formData
      });
      
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      
      const result = await response.json();
      console.log('Upload response:', result);
      
      return {
        success: result?.success || false,
        message: result?.message || '',
        data: result?.data || null
      };
    } catch (error) {
      console.error('Upload image error:', error);
      return {
        success: false,
        message: error.message || 'Upload failed'
      };
    }
  }
};

// ==================== HOME SLIDER API ====================
export const homeSliderAPI = {
  getAll: async () => {
    try {
      console.log('Fetching all slides...');
      const response = await apiRequest('/slider.php?action=getAll');
      
      console.log('Home Slider API Response (GetAll):', response);
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || [],
          message: response.message || '',
        };
      } else {
        console.error('Invalid response format:', response);
        return {
          success: false,
          message: 'Invalid response format from server',
          data: []
        };
      }
    } catch (error) {
      console.error('Home Slider API Error (GetAll):', error);
      return {
        success: false,
        message: error.message || 'Network error. Check backend server.',
        data: []
      };
    }
  },

  getActive: async () => {
    try {
      const response = await apiRequest('/slider.php?action=getActive');
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || [],
          message: response.message || '',
        };
      } else {
        return {
          success: false,
          message: 'Invalid response from server',
          data: []
        };
      }
    } catch (error) {
      console.error('Home Slider API Error (Active):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: []
      };
    }
  },

  getById: async (id) => {
    try {
      const response = await apiRequest(`/slider.php?action=getById&id=${id}`);
      
      if (response && (response.success === true || response.success === false)) {
        return {
          success: response.success,
          data: response.data || {},
          message: response.message || '',
        };
      } else {
        return {
          success: false,
          message: 'Invalid response from server',
          data: {}
        };
      }
    } catch (error) {
      console.error('Home Slider API Error (GetById):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: {}
      };
    }
  },

  create: async (formData) => {
    try {
      console.log('Creating slide with data:', formData);
      const response = await apiRequest('/slider.php?action=create', 'POST', formData);
      
      console.log('Create response:', response);
      return {
        success: response?.success || false,
        data: response?.data || {},
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Home Slider API Error (Create):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: {}
      };
    }
  },

  update: async (id, formData) => {
    try {
      console.log(`Updating slide ${id} with data:`, formData);
      const response = await apiRequest(`/slider.php?action=update&id=${id}`, 'POST', formData);
      
      return {
        success: response?.success || false,
        data: response?.data || {},
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Home Slider API Error (Update):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: {}
      };
    }
  },

  delete: async (id) => {
    try {
      const response = await apiRequest(`/slider.php?action=delete&id=${id}`, 'DELETE');
      
      return {
        success: response?.success || false,
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Home Slider API Error (Delete):', error);
      return {
        success: false,
        message: error.message || 'Network error'
      };
    }
  },

  uploadImage: async (file) => {
    try {
      const formData = new FormData();
      formData.append('image', file);
      
      console.log('Uploading image:', file.name);
      const response = await apiRequest('/slider.php?action=uploadImage', 'POST', formData, true);
      
      return {
        success: response?.success || false,
        data: response?.data || {},
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Home Slider API Error (Upload):', error);
      return {
        success: false,
        message: error.message || 'Network error',
        data: {}
      };
    }
  },

  reorder: async (slides) => {
    try {
      const response = await apiRequest('/slider.php?action=reorder', 'POST', { slides });
      
      return {
        success: response?.success || false,
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Home Slider API Error (Reorder):', error);
      return {
        success: false,
        message: error.message || 'Network error'
      };
    }
  },

  toggleStatus: async (id, status) => {
    try {
      const formData = new FormData();
      formData.append('is_active', status);
      
      console.log(`Toggling slide ${id} to status: ${status}`);
      const response = await apiRequest(`/slider.php?action=toggleStatus&id=${id}`, 'POST', formData, true);
      
      return {
        success: response?.success || false,
        message: response?.message || ''
      };
    } catch (error) {
      console.error('Home Slider API Error (Toggle):', error);
      return {
        success: false,
        message: error.message || 'Network error'
      };
    }
  }
};

// ==================== TEST FUNCTION ====================
export const testBackendConnection = async () => {
  console.log('🔌 Testing backend connection...');
  
  try {
    const response = await fetch('http://localhost/college-website/backend/test.php');
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const text = await response.text();
    
    try {
      const data = JSON.parse(text);
      return {
        success: true,
        message: 'Backend connected successfully',
        data: data
      };
    } catch {
      return {
        success: false,
        message: 'Backend returned non-JSON response',
        raw: text.substring(0, 200)
      };
    }
    
  } catch (error) {
    console.error('Connection test failed:', error);
    return {
      success: false,
      message: `Cannot connect to backend: ${error.message}`,
      suggestion: 'Check if XAMPP is running and backend files exist'
    };
  }
};

// Default export
export default apiRequest;